import React from 'react';
import '../../App.css';
import './NotFound.css';

export const NotFound = () => {
    return (
        <div className="NotFound">
            <h1>404 - Page Not Found</h1>
            <p>The page you are looking for does not exist.</p>
        </div>
    );
};
